import { useEffect } from "react";
import CommonDialog from "../../../../../common/components/dialog/CommonDialog";
import { AddCreditCardIcon, CheckIcon, CloseIcon, CreditCardIcon, WalletIcon } from "../../../../../assets/icons";
import { useLazyGetWalletEnquiryQuery } from "../../../../../service/virtual-wallet-service";
import { useLazyGetCustomerSavedCardsQuery } from "../../../../../service/charge-service";
import styles from "../unit-threshold-setup.module.scss";

interface PaymentMethodSheetProps {
	selectedId: string | null;
	onSelect: (id: string, label: string, subtitle: string) => void;
	onClose: () => void;
}

export const PaymentMethodSheet = ({ selectedId, onSelect, onClose }: PaymentMethodSheetProps) => {
	const [fetchWallet, { data: wallet, isFetching: walletLoading }] = useLazyGetWalletEnquiryQuery();
	const [fetchCards, { data: cardsResult, isFetching: cardsLoading }] = useLazyGetCustomerSavedCardsQuery();

	useEffect(() => {
		fetchWallet();
		fetchCards();
	}, [fetchWallet, fetchCards]);

	const activeCards = cardsResult?.savedCards ?? [];
	const balanceText = wallet != null ? `₦${wallet.accountBalance.toLocaleString()}` : walletLoading ? "…" : "₦0.00";

	return (
		<CommonDialog onCloseDialog={onClose} noPadding borderRadius="1.354rem" bottomSheetOnMobile>
			<div className={styles.paymentSheet}>
				{/* Header */}
				<div className={styles.paymentSheetHeader}>
					<button className={styles.paymentSheetClose} onClick={onClose}>
						<CloseIcon width={25} height={25} />
					</button>
					<span className={styles.paymentSheetTitle}>Payment Method</span>
					<div className={styles.paymentSheetTitleSpacer} />
				</div>

				{/* Body */}
				<div className={styles.paymentSheetBody}>
					{/* Wallet */}
					<span className={styles.paymentSheetSectionLabel}>Wallet</span>
					<button
						className={styles.paymentWalletTile}
						onClick={() => onSelect("wallet", "Wallet", balanceText)}
					>
						<div className={styles.paymentOptionIcon}>
							<WalletIcon width={20} height={20} />
						</div>
						<div className={styles.paymentOptionInfo}>
							<span className={styles.paymentOptionLabel}>Wallet</span>
							<span className={styles.paymentOptionSubtitle}>{balanceText}</span>
						</div>
						{selectedId === "wallet" && <CheckIcon width={20} height={20} className={styles.paymentOptionCheck} />}
					</button>

					{/* Cards */}
					<span className={styles.paymentSheetSectionLabel}>Cards</span>
					<div className={styles.paymentCardsContainer}>
						{cardsLoading ? (
							<div className={styles.paymentCardsEmpty}>
								<span className={styles.paymentCardsEmptyText}>Loading…</span>
							</div>
						) : activeCards.length > 0 ? (
							activeCards.map(card => (
							<button
								key={card.id}
								className={styles.paymentCardRow}
								onClick={() => onSelect(card.id.toString(), card.panNumber, card.cardType)}
							>
								<div className={styles.paymentOptionIcon}>
									<CreditCardIcon width={20} height={20} />
								</div>
								<div className={styles.paymentOptionInfo}>
									<span className={styles.paymentOptionLabel}>{card.panNumber}</span>
									<span className={styles.paymentOptionSubtitle}>{card.cardType}</span>
								</div>
								{selectedId === card.id.toString() && <CheckIcon width={20} height={20} className={styles.paymentOptionCheck} />}
							</button>
						))
						) : (
							<div className={styles.paymentCardsEmpty}>
								<div className={styles.paymentCardsEmptyIcon}>
									<AddCreditCardIcon width={25} height={25} />
								</div>
								<span className={styles.paymentCardsEmptyText}>You don't have any cards</span>
							</div>
						)}
					</div>
				</div>
			</div>
		</CommonDialog>
	);
};
